import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

// V1's ReportModal content in the pitch inbox's modal language (same flow, same copy);
// behavior types render as the quick-reply pill style with a selected state
function PitchReportModal({
  show, onHide, abusiveBehaviorTypes, behaviorTypes, onToggleBehaviorType, onDescriptionChange, onSubmit,
}) {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered contentClassName="pitch-inbox">
      <Modal.Header closeButton>
        <Modal.Title className="paragraph-lg text-destructive-80">
          <i className="fa-solid fa-triangle-exclamation me-2" />
          Report this pitch anonymously
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="alert pi-reply-note mb-3">
          Qwoted reviews all reported pitches and takes action ranging from a gentle email to account disablement for
          off-topic, spammy, AI-generated, or otherwise inappropriate content. Your report is kept confidential and
          anonymous. Please share why you&apos;re reporting this pitch:
        </div>
        <p className="paragraph-sm text-secondary mb-2">Please select those which describe the inappropriate behavior:</p>
        <div className="d-flex flex-wrap gap-2 mb-3">
          {Object.keys(abusiveBehaviorTypes).map((key) => (
            <button
              key={key}
              type="button"
              className={`pi-quick-reply ${behaviorTypes && behaviorTypes.includes(key) ? 'selected' : ''}`}
              onClick={() => onToggleBehaviorType(key)}
            >
              {abusiveBehaviorTypes[key]}
            </button>
          ))}
        </div>
        <textarea
          className="form-control"
          placeholder="Please elaborate on your concerns."
          onChange={onDescriptionChange}
          rows="6"
          aria-label="Report description"
        />
      </Modal.Body>

      <Modal.Footer className="border-top-0 pt-0">
        <button type="button" className="btn btn-danger" onClick={onSubmit}>
          Report
        </button>
        <button type="button" className="btn btn-secondary" onClick={onHide}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
}

PitchReportModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types -- server-serialized behavior-types map
  abusiveBehaviorTypes: PropTypes.object.isRequired,
  behaviorTypes: PropTypes.arrayOf(PropTypes.string),
  onToggleBehaviorType: PropTypes.func.isRequired,
  onDescriptionChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default PitchReportModal;
